export default __webpack_public_path__ + "static/media/about_icon.1b5ed174.svg";